import type { ParceirosFormData } from "@/components/parceiros/schema";
import { getTrackingParams } from "./tracking";

/**
 * Posta o lead no endpoint interno `/api/parceiros-lead` (Vercel Edge Function),
 * que por sua vez faz a chamada server-side pro HubSpot CRM API com `HUBSPOT_API_KEY`.
 *
 * Por que não chamamos o HubSpot direto do frontend: precisaria expor a API key
 * privada no bundle, o que é um risco de segurança. A function age como proxy
 * server-side.
 */
export async function submitParceiroToHubSpot(
  payload: ParceirosFormData,
  eventID?: string
): Promise<void> {
  const tracking = getTrackingParams();

  const res = await fetch("/api/parceiros-lead", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fullname: payload.fullname,
      email: payload.email,
      phone: payload.phone,
      ja_atua: payload.ja_atua,
      carteira_size: payload.carteira_size,
      certificacao: payload.certificacao,
      lgpd_consent: payload.lgpd_consent,
      // event_id compartilhado com o Pixel. Server usa o mesmo no CAPI pra
      // o Meta deduplicar Lead browser vs server.
      event_id: eventID,
      tracking,
    }),
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`Submit failed (${res.status}): ${text}`);
  }
}
